<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <h3 class="card-title">{{$t('medium_grant.diligence__1_capacity_questionaire')}}</h3>
        <p>{{$t('medium_grant.diligence__2_capacity_questionaire_sub2')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-4"></div>
        <h4 class="card-title"><strong>{{$t('medium_grant.diligence__9_checklist')}}</strong></h4>
        <p class="mt-3 white-space-pre">{{$t('medium_grant.diligence__9_checklist_sub')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-9">
        <table width="100%">
          <tr>
            <td>
              <base-checkbox name="checkbox" v-model="GrantForm.model.diligence.checklist1c">
                {{$t('medium_grant.diligence__9_checklist1c')}}
              </base-checkbox>
            </td>
            <td>
              {{$t('medium_grant.diligence__9_checklist1c_label')}}
            </td>
            <td>
              <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.articlesOfIncorporation" :file-data="GrantForm.files.diligence.articlesOfIncorporation" :size-limit="GrantForm.fileSizeLimit" :is-editable="GrantForm.isEditable" section="diligence.articlesOfIncorporation"></upload-file>
            </td>
          </tr>
          <tr>
            <td>
              <base-checkbox name="checkbox" v-model="GrantForm.model.diligence.checklist1c2">
                {{$t('medium_grant.diligence__9_checklist1c2')}}
              </base-checkbox>
            </td>
            <td>
              {{$t('medium_grant.diligence__9_checklist1c2_label')}}
            </td>
            <td>
              <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.orgInCountry" :file-data="GrantForm.files.diligence.orgInCountry" :is-editable="GrantForm.isEditable" :size-limit="GrantForm.fileSizeLimit" section="diligence.orgInCountry"></upload-file>
            </td>
          </tr>
          <tr>
            <td>
              <base-checkbox name="checkbox" v-model="GrantForm.model.diligence.checklist3">
                {{$t('medium_grant.diligence__9_checklist3')}}
              </base-checkbox>
            </td>
            <td>
              {{$t('medium_grant.diligence__9_checklist3_label')}}
            </td>
            <td>
              <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.certificationOfTax" :file-data="GrantForm.files.diligence.certificationOfTax" :is-editable="GrantForm.isEditable" :size-limit="GrantForm.fileSizeLimit" section="diligence.certificationOfTax"></upload-file>
            </td>
          </tr>
          <tr>
            <td>
              <base-checkbox name="checkbox" v-model="GrantForm.model.diligence.checklist4a">
                {{$t('medium_grant.diligence__9_checklist4a')}}
              </base-checkbox>
            </td>
            <td>
              {{$t('medium_grant.diligence__9_checklist4a_label')}}
            </td>
            <td>
              <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.auditReport" :file-data="GrantForm.files.diligence.auditReport" :is-editable="GrantForm.isEditable" :size-limit="GrantForm.fileSizeLimit" section="diligence.auditReport"></upload-file>
            </td>
          </tr>
          <tr>
            <td>
              <base-checkbox name="checkbox" v-model="GrantForm.model.diligence.checklist4b">
                {{$t('medium_grant.diligence__9_checklist4b')}}
              </base-checkbox>
            </td>
            <td>
              {{$t('medium_grant.diligence__9_checklist4b_label')}}
            </td>
            <td>
              <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.accountingProcurement" :file-data="GrantForm.files.diligence.accountingProcurement" :size-limit="GrantForm.fileSizeLimit" :is-editable="GrantForm.isEditable" section="diligence.accountingProcurement"></upload-file>
            </td>
          </tr>
          <tr>
            <td>
              <base-checkbox name="checkbox" v-model="GrantForm.model.diligence.checklist5c">
                {{$t('medium_grant.diligence__9_checklist5c')}}
              </base-checkbox>
            </td>
            <td>
              {{$t('medium_grant.diligence__9_checklist5c_label')}}
            </td>
            <td>
              <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.timesheetForm" :file-data="GrantForm.files.diligence.timesheetForm" :is-editable="GrantForm.isEditable" :size-limit="GrantForm.fileSizeLimit" section="diligence.timesheetForm"></upload-file>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <p class="mt-3">{{$t('medium_grant.diligence__9_iucn_may_request')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-4"></div>
        <h4 class="card-title"><strong>{{$t('medium_grant.diligence__9_certification')}}</strong></h4>
        <p class="mt-3 white-space-pre">{{$t('medium_grant.diligence__9_certification_sub')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3">
        <div class="mt-5"></div>
        <div class="mb-2">
          <label>{{$t('medium_grant.diligence__9_signature')}}</label>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.signature" :file-data="GrantForm.files.diligence.signature" :is-editable="GrantForm.isEditable" :size-limit="GrantForm.fileSizeLimit" section="diligence.signature"></upload-file>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
          name="diligence.name"
          v-model="GrantForm.model.diligence.name"
          :error="getError('diligence.name')"
          v-validate="'required'"
          :data-vv-as="$t('medium_grant.diligence__9_name')"
          :label="$t('medium_grant.diligence__9_name')"
          :placeholder="$t('medium_grant.diligence__9_name')"
        >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
          name="diligence.position"
          v-model="GrantForm.model.diligence.position"
          :error="getError('diligence.position')"
          v-validate="'required'"
          :data-vv-as="$t('medium_grant.diligence__9_position')"
          :label="$t('medium_grant.diligence__9_position')"
          :placeholder="$t('medium_grant.diligence__9_position')"
        >
          </textarea>
        </div>
        <base-input
          name="diligence.date"
          v-model="GrantForm.model.diligence.date"
          :error="getError('diligence.date')"
          v-validate="'required'"
          :data-vv-as="$t('medium_grant.diligence__9_date')"
          :placeholder="$t('medium_grant.diligence__9_date')"
        >
          <label>{{$t('medium_grant.diligence__9_date')}}</label>
          <el-date-picker
            type="date"
            v-model="submitDate"
            :placeholder="$t('medium_grant.diligence__9_date')"
          >
          </el-date-picker>
        </base-input>
      </div>
      <div class="col-lg-1"></div>
      <div class="col-lg-3">
        <div class="mt-5"></div>
        <div>
          <label>{{$t('medium_grant.diligence__9_signature_org')}}</label>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.orgStamp" :file-data="GrantForm.files.diligence.orgStamp" :is-editable="GrantForm.isEditable" :size-limit="GrantForm.fileSizeLimit" section="diligence.orgStamp"></upload-file>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import {DatePicker} from 'element-ui';
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm,
        submitDate: '',
        moment: ''
      }
    },
    beforeMount() {
      this.moment = require('moment');

      if (GrantForm.model.diligence.date !== undefined) {
        this.submitDate = GrantForm.model.diligence.date;
      }
    },
    components: {
      [DatePicker.name]: DatePicker
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    },
    watch: {
      submitDate(newValue, oldValue) {
        GrantForm.model.diligence.date = this.moment(newValue).format('YYYY-MM-DD');
      }
    }
  }
</script>
<style scoped>
  p.white-space-pre {
    white-space: pre-wrap;
  }
</style>
